import r2wc from "@r2wc/react-to-web-component";
import { VehicleCategorySelector } from "@fm/ui";

const VehicleCategorySelectorWebComponent = r2wc(VehicleCategorySelector, {
  props: {
    label: "string",
    categories: "json", // Array of category objects
    value: "json", // VehicleCategorySelection object
    onChange: "function",
    placeholder: "string",
    error: "string",
    helpText: "string",
    id: "string",
    className: "string",
    showLabel: "boolean",
    showWarning: "boolean",
    disabled: "boolean",
  },
  events: {
    onChange: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-vehicle-category-selector")) {
  customElements.define(
    "fm-vehicle-category-selector",
    VehicleCategorySelectorWebComponent,
  );
}
